import { cn } from "@/shared/lib";

type SpinnerProps = { className?: string };

// Крутящийся круг цвета текста: что-то делается прямо сейчас. Что именно — подпись рядом,
// поэтому экранному диктору спиннер не нужен.
export const Spinner = ({ className }: SpinnerProps) => (
  <span
    data-slot="spinner"
    aria-hidden="true"
    className={cn(
      "inline-block size-3.5 shrink-0 animate-spin rounded-full border-2 border-current/30 border-t-current motion-reduce:animate-[spin_2s_linear_infinite]",
      className,
    )}
  />
);
